import React from 'react';
import { Box, Skeleton } from '@mui/material';
import * as cardStyles from '../featuredCard/styles';
import * as styles from './styles';

// Mirrors featuredCard's DOM shape 1:1 (same card/cover/body tokens) so the
// grid holds its layout with zero shift once real cards swap in.
function FeaturedCardSkeleton() {
    return (
        <Box sx={cardStyles.card}>
            <Box sx={cardStyles.coverColor}>
                <Skeleton
                    variant="rectangular"
                    animation="pulse"
                    sx={{ position: 'absolute', inset: 0, ...styles.tile }}
                />
                <Box sx={cardStyles.coverBottom}>
                    <Skeleton
                        variant="rounded"
                        animation="pulse"
                        sx={{ ...cardStyles.publisherLogo, ...styles.dimText }}
                    />
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Skeleton variant="text" animation="pulse" width="70%" height={22} sx={styles.dimText} />
                        <Skeleton variant="text" animation="pulse" width="40%" height={16} sx={styles.dimText} />
                    </Box>
                </Box>
            </Box>
            <Box sx={cardStyles.body}>
                <Box sx={{ minHeight: '20px' }} />
                <Box sx={cardStyles.actions}>
                    <Skeleton variant="rounded" animation="pulse" sx={styles.button} />
                    <Skeleton variant="rounded" animation="pulse" sx={styles.shareButton} />
                </Box>
            </Box>
        </Box>
    );
}

export default FeaturedCardSkeleton;
